import { type Badge } from 'lib/sdks/search';

export const getSponsoredBadge = (badges: Badge[]) => {
  return badges?.find(
    badge => badge.type === 'sponsored' || badge.key === 'sponsored',
  );
};

export const hasSponsoredBadge = (badges: Badge[]) => {
  return getSponsoredBadge(badges) !== undefined;
};
